import axios from '@axios'

export default {
  // auth
  loginOAuth: code => axios.request({
    url: `${
      process.env.VUE_APP_NOVITATUS_AUTH_SERVER
    }/oauth/token?grant_type=authorization_code&client_id=novitatus-web&scope=assembleias:ler assembleias:escrever assembleias:votar assembleias:comentar&code=${code}&redirect_uri=${encodeURIComponent(
      process.env.VUE_APP_AUTH_CALLBACK,
    )}`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-encoded',
    },
  }),
  refreshToken: rt => axios.request({
    url: `${process.env.VUE_APP_NOVITATUS_AUTH_SERVER}/oauth/token?grant_type=refresh_token&client_id=novitatus-web&refresh_token=${rt}`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-encoded',
    },
  }),
  login: credenciais => axios.post(
    `${process.env.VUE_APP_NOVITATUS_API}/auth/login`,
    credenciais,
  ),
  trocarConta: empresaId => axios.post(
    `${process.env.VUE_APP_NOVITATUS_API}/auth/trocarconta/${empresaId}`,
  ),
  esqueceuSenha: esqueceuSenha => axios.post(
    `${process.env.VUE_APP_NOVITATUS_API}/auth/esqueceusenha`,
    esqueceuSenha,
  ),
  novaSenha: novaSenha => axios.post(
    `${process.env.VUE_APP_NOVITATUS_API}/auth/novasenha`,
    novaSenha,
  ),
  confirmacao: confirmacao => axios.post(
    `${process.env.VUE_APP_NOVITATUS_API}/auth/confirmacao`,
    confirmacao,
  ),
  cadastro: cadastro => axios.post(
    `${process.env.VUE_APP_NOVITATUS_API}/auth/cadastro`,
    cadastro,
  ),
  loginSocial: token => axios.post(
    `${process.env.VUE_APP_NOVITATUS_API}/auth/loginsocial`,
    token,
  ),
}
